import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useSiteActivationContext } from "@/components/signup/site-activation/hooks/site-activation-context";
import { Button } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";

import { PaymentDetailsHeading } from "..";

export const PaymentDetailsContent = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { setPaymentDetailsView, activateSite, isSubmitting, hasSubmitted } =
        useSiteActivationContext();

    const handleSubmit = () => {
        createAnalyticsEvent({
            event: "clicked",
            eventComponent: "button",
            eventName: "bxp.signup.paymentDetailsSubmit"
        }).fire("signup");

        const privacyPolicy =
            document.getElementById("privacy-policy-text")?.innerHTML || "";
        activateSite({ privacyPolicy });
    };

    const isLoading = isSubmitting || hasSubmitted;

    return (
        <>
            <PaymentDetailsHeading />
            <p css={subtitleCss}>
                <FormattedMessage
                    id="BxpSignup.PaymentDetailsSubtitle"
                    defaultMessage="to start a Rovo Dev 30 day free trial"
                />
            </p>
            <div css={actionsCss}>
                <Button
                    variant="secondary"
                    onClick={() =>
                        setPaymentDetailsView({ view: "site-setup" })
                    }
                    isDisabled={isLoading}
                    css={buttonCss}
                >
                    <FormattedMessage
                        id="BxpSignup.PaymentDetailsBack"
                        defaultMessage="Back"
                    />
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    isLoading={isLoading}
                    isDisabled={isLoading}
                    css={buttonCss}
                >
                    <FormattedMessage
                        id="BxpSignup.PaymentDetailsSubmit"
                        defaultMessage="I've added my payment details"
                    />
                </Button>
            </div>
        </>
    );
};

const buttonCss = css({
    fontSize: 18,
    height: 45.12,
    whiteSpace: "nowrap"
});

const subtitleCss = css({
    color: wacToken("color.neutral.dark400"),
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    margin: "0 0 24px",
    textAlign: "center"
});

const actionsCss = css({
    display: "flex",
    gap: 16,
    justifyContent: "center",
    padding: "12px"
});
